import TOP_BARS from '@/utils/topBars';

export default [
  {
    path: '/calendar',
    name: 'calendar',
    meta: {
      title: 'My Calendar',
      topBar: TOP_BARS.BY_ROLE
    },
    component: () => import('@/views/Calendar')
  },
  {
    path: '/material',
    name: 'material',
    meta: {
      title: 'Training Material',
      topBar: TOP_BARS.BY_ROLE
    },
    component: () => import('@/views/Material')
  }
];
